import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TenantDto } from '@nusign/picflow-backend-types';
import { lastValueFrom } from 'rxjs';
import { AppConfigService } from '../providers/config.service';
import { DataLoaderService } from './data-loader.service';

@Injectable({
  providedIn: 'root',
})
export class PublicTenantService {
  private http = inject(HttpClient);
  private config = inject(AppConfigService);
  private loader = inject(DataLoaderService);

  public async getTenant(tenantPath: string): Promise<TenantDto> {
    return this.loader.get('public-tenant' + tenantPath, async () => {
      try {
        return await lastValueFrom(
          this.http.get<TenantDto>(`${this.config.apiEndpoint}/tenants/path/${tenantPath}?ignore_503_error=true`)
        );
      } catch (err) {
        if (!(err instanceof HttpErrorResponse)) throw err;
        if (err.status === 503) throw err;
        return;
      }
    });
  }

  public async getTenantFromCustomDomain(customDomain: string): Promise<TenantDto> {
    return this.loader.get('public-tenant' + customDomain, async () => {
      try {
        return await lastValueFrom(
          this.http.get<TenantDto>(`${this.config.apiEndpoint}/tenants/domain?ignore_503_error=true`)
        );
      } catch (err) {
        if (!(err instanceof HttpErrorResponse)) throw err;
        if (err.status === 503) throw err;
        return;
      }
    });
  }
}
